import React, { useEffect, useState } from "react";
import { Redirect, Switch, Route, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { usersSlice } from "../_redux/users/usersSlice";
import NewChart from "../_metronic/_partials/charts/NewChart";
import PrivateRoute from "./PrivateRoute";
import ProductsPage from "./pages/products/ProductsPage";
import InvoicesPage from "./pages/invoices/InvoicesPage";
import CustomersPage from "./pages/customers/CustomersPage";
import Information from "./pages/company/information/Information";
import Users from "./pages/company/users/Users";
import { CustomersUIProvider } from "./pages/customers/CustomersUIContext";
import Subscription from "./pages/subscription/Subscription";
import SalesByCategoryPage from "./pages/analytics/salesByCategory";
import SalesByProductPage from "./pages/analytics/salesBySummary";
import SalesByUserPage from "./pages/analytics/salesByUser";
import SalesByItemPage from "./pages/analytics/salesByItem";
import TaxReportPage from "./pages/analytics/taxReportPage";
import DiscountReportPage from "./pages/analytics/discountReport";
import SalesByTimePage from "./pages/analytics/salesByTime";
import Taxes from "./pages/company/taxes/Taxes";
import Pos from "./pages/company/pos/Pos";
import Role from "./pages/company/role/Role";
import { UserEditForm } from "./pages/company/company-edit-Dialog/users/UsersEditForm";
import PaymentChannels from "./pages/company/payment-channels/PaymentChannels";
import CategoriesPage from "./pages/products/categories/CategoriesPage";
import DiscountsPage from "./pages/products/product-discount/DiscountsPage";
import StoresPage from "./pages/company/company-edit-Dialog/stores/StoresPage";
import UserSettings from "./pages/user/UserSettings";
import { handlePagesAccessAsPerRolePermissions, isPageAccessAllowed } from "../helpers/helpers";
import AnalyticsView from "./pages/analytics/analyticsView/AnalyticsView";
import Loyalty from "./pages/company/loyalty/Loyalty";
import Integration from "./pages/integration/Integration";
import ZatcaPosDetails from "./pages/integration/zatca/ZatcaPosDetails";
import { StoresEditForm } from "./pages/company/company-edit-Dialog/stores/StoresEditForm";
const { actions } = usersSlice;

export default function BasePage() {
  const history = useHistory();

  const dispatch = useDispatch();

  const [userAccess, setUserAccess] = useState({});

  const { user } = useSelector((state) => state.auth);

  let backOfficeAccess = user?.rolePayload?.backOffice;
  let access = user && Object.values(user?.rolePayload?.backOfficePayload);

  let dashboard = access[0]?.selected;
  let customers = access[1]?.selected;
  let invoices = access[2];
  let products = access[3];
  let company = access[4];
  let createData = access[5]?.selected;
  let editData = access[6]?.selected;
  let deleteData = access[7]?.selected;
  let liveChat = access[8]?.selected;
  let zatcaIntegration = access[9]?.selected;
  // let userInformation = access[9]?.selected;

  useEffect(() => {
    setUserAccess({
      company: company,
      invoices: invoices,
      editData: editData,
      products: products,
      liveChat: liveChat,
      customers: customers,
      dashboard: dashboard,
      deleteData: deleteData,
      createData: createData,
      zatcaIntegration: zatcaIntegration,
    });
      //eslint-disable-next-line
  }, [user, company, editData, invoices, liveChat, products, customers, dashboard, deleteData, createData]);

  useEffect(() => {
    dispatch(
      actions.userRoleAccess({
        entities: userAccess,
      }),
    );
  }, [dispatch, userAccess]);

  const customersUIEvents = {
    newCustomerButtonClick: () => {
      history.push("/e-commerce/products/new");
    },
    openEditCustomerDialog: (id) => {
      history.push(`/e-commerce/products/${id}/edit`);
    },
    openViewCustomerDialog: (id) => {
      history.push(`/e-commerce/products/${id}/delete`);
    },
    openDeleteCustomerDialog: () => {
      history.push(`/e-commerce/products/deleteProducts`);
    },
    openDeleteCustomersDialog: () => {
      history.push(`/e-commerce/products/fetch`);
    },
    openFetchCustomersDialog: () => {
      history.push("/e-commerce/products/updateStatus");
    },
    openUpdateCustomersStatusDialog: () => {
      history.push("/e-commerce/products/updateStatus");
    },
    openCustomerActionsDialog: () => {
      history.push("/e-commerce/products/updateStatus");
    },
  };
  const { language } = useSelector((state) => state.auth);

  useEffect(() => {
    let body = document.getElementById("kt_body");
    if (language === "arabic") {
      body.classList.add("body-arabic-font");
    } else {
      body.classList.remove("body-arabic-font");
    }
  }, [language]);

  return (
    <CustomersUIProvider customersUIEvents={customersUIEvents}>
      <Switch>
        {/* {user && !user?.accountVerified && backOfficeAccess && access[0]?.selected ? (
          // <Redirect exact from="/" to="/analytics/sales-summary" />
          <Redirect exact from="/" to="/analytic-summary" />
        ) : // ) : user?.accountVerified && !(user?.companyId?.profession || user?.companyId?.industry) ? (
        user?.accountVerified && backOfficeAccess && access[0]?.selected ? (
          // <Redirect exact from="/" to="/user-or-company" />
          <Redirect exact from="/" to="/analytics/sales-summary" />
        ) : user && backOfficeAccess ? (
          // <Redirect exact from="/" to="/user-or-company" />
          <Redirect exact from="/" to="/user-settings" />
        ) : ( */}
        <Redirect exact from="/" to={handlePagesAccessAsPerRolePermissions(backOfficeAccess, access)} />

        <PrivateRoute path="/invoices" routeAccess={isPageAccessAllowed("/invoices", backOfficeAccess, access)} component={InvoicesPage} />
        <PrivateRoute path="/customers" routeAccess={isPageAccessAllowed("/customers", backOfficeAccess, access)} component={CustomersPage} />
        <PrivateRoute path="/products" routeAccess={isPageAccessAllowed("/products", backOfficeAccess, access)} component={ProductsPage} />
        <PrivateRoute path="/categories" routeAccess={isPageAccessAllowed("/categories", backOfficeAccess, access)} component={CategoriesPage} />
        <PrivateRoute path="/discounts" routeAccess={isPageAccessAllowed("/discounts", backOfficeAccess, access)} component={DiscountsPage} />
        <PrivateRoute path="/information" routeAccess={isPageAccessAllowed("/information", backOfficeAccess, access)} component={Information} />
        <PrivateRoute path="/user-settings" routeAccess={backOfficeAccess || !backOfficeAccess} component={UserSettings} />
        <PrivateRoute path="/subscription" routeAccess={isPageAccessAllowed("/subscription", backOfficeAccess, access)} component={Subscription} />
        <PrivateRoute
          path="/subscription/new"
          routeAccess={isPageAccessAllowed("/subscription/new", backOfficeAccess, access)}
          component={Subscription}
        />
        {/* <PrivateRoute path="/subscription/add-payment-card" routeAccess={backOfficeAccess && access[7]?.selected} component={Subscription} /> */}
        <PrivateRoute
          path="/subscription/add-payment-card"
          routeAccess={isPageAccessAllowed("/subscription/add-payment-card", backOfficeAccess, access)}
          component={Subscription}
        />
        <PrivateRoute path="/users" routeAccess={isPageAccessAllowed("/users", backOfficeAccess, access)} component={Users} />
        <PrivateRoute path="/users/add" routeAccess={isPageAccessAllowed("/users/add", backOfficeAccess, access)} component={Users} />
        <Route path="/new-chart" component={NewChart} />
        <PrivateRoute
          path="/analytics/sales-summary"
          routeAccess={isPageAccessAllowed("", backOfficeAccess, access, "analytics")}
          component={AnalyticsView}
        />
        <PrivateRoute
          path="/sales-by-product"
          routeAccess={isPageAccessAllowed("", backOfficeAccess, access, "analytics")}
          component={SalesByProductPage}
        />
        <PrivateRoute
          path="/sales-by-category"
          routeAccess={isPageAccessAllowed("", backOfficeAccess, access, "analytics")}
          component={SalesByCategoryPage}
        />
        <PrivateRoute
          path="/sales-by-user"
          routeAccess={isPageAccessAllowed("", backOfficeAccess, access, "analytics")}
          component={SalesByUserPage}
        />
        <PrivateRoute
          path="/sales-by-payment-channel"
          routeAccess={isPageAccessAllowed("", backOfficeAccess, access, "analytics")}
          component={SalesByItemPage}
        />
        <PrivateRoute
          path="/sales-by-time"
          routeAccess={isPageAccessAllowed("", backOfficeAccess, access, "analytics")}
          component={SalesByTimePage}
        />
        <PrivateRoute path="/tax-report" routeAccess={isPageAccessAllowed("", backOfficeAccess, access, "analytics")} component={TaxReportPage} />
        <PrivateRoute
          path="/discount-report"
          routeAccess={isPageAccessAllowed("", backOfficeAccess, access, "analytics")}
          component={DiscountReportPage}
        />
        <PrivateRoute path="/user/setup-owner-pos-pin" routeAccess={backOfficeAccess && access[8]?.selected} component={Users} />
        <PrivateRoute path="/users/edit/delete" routeAccess={backOfficeAccess && access[8]?.selected} component={UserEditForm} />
        <PrivateRoute path="/taxes" routeAccess={isPageAccessAllowed("/taxes", backOfficeAccess, access)} component={Taxes} />
        <PrivateRoute path="/pos-devices" routeAccess={isPageAccessAllowed("/pos-devices", backOfficeAccess, access)} component={Pos} />
        <PrivateRoute path="/roles" routeAccess={isPageAccessAllowed("/roles", backOfficeAccess, access)} component={Role} />
        <PrivateRoute path="/loyalty" routeAccess={isPageAccessAllowed("/loyalty", backOfficeAccess, access)} component={Loyalty} />
        <PrivateRoute path="/zatca/:id" routeAccess={isPageAccessAllowed("/zatca", backOfficeAccess, access)} component={ZatcaPosDetails} />
        <PrivateRoute path="/zatca" routeAccess={isPageAccessAllowed("/zatca", backOfficeAccess, access)} component={Integration} />
        <PrivateRoute exact path="/stores" routeAccess={isPageAccessAllowed("/stores", backOfficeAccess, access)} component={StoresPage} />
        <PrivateRoute path="/stores/edit/:id" routeAccess={isPageAccessAllowed("/stores", backOfficeAccess, access)} component={StoresEditForm} />
        <PrivateRoute path="/stores/add" routeAccess={isPageAccessAllowed("/stores", backOfficeAccess, access)} component={StoresEditForm} />
        <PrivateRoute
          path="/payment-channels"
          routeAccess={isPageAccessAllowed("/payment-channels", backOfficeAccess, access)}
          component={PaymentChannels}
        />
        <Redirect to="/error/error-v3" />
      </Switch>
    </CustomersUIProvider>
  );
}
